import { Modal } from 'antd';
import { getDownloadUrl } from '@/utils';
import { useGetInquiryLettersQuery } from '@/services/parent-api';
import { DownloadSvg } from '@/assets/icons';
import Table from '@/components/table';
import Button from '@/components/button';

const LettersModal = ({ parentId, inquiryId, onClose }) => {
  const { data, isFetching } = useGetInquiryLettersQuery({ parentId, inquiryId }, { skip: !inquiryId });

  const columns = [
    {
      title: 'Letter',
      dataIndex: 'letterName',
    },
    {
      title: 'Sent To',
      key: 'sent-to',
      render: (_, record) => record.letterRecipient.recipientType.name,
    },
    {
      title: 'Action',
      key: 'action',
      align: 'right',
      render: (_, record) => (
        <Button
          type="link"
          href={getDownloadUrl(`/parents/${parentId}/letters/${record.parentLetterId}/download`)}
          icon={<DownloadSvg />}
          title="Download"
        />
      ),
    },
  ];

  return (
    <>
      <Modal
        title="View Letters"
        open={!!inquiryId}
        cancelText="Close"
        onCancel={onClose}
        destroyOnClose
        width={800}
        footer={(_, { CancelBtn }) => <CancelBtn />}
      >
        <Table
          columns={columns}
          dataSource={!isFetching && data}
          rowKey="parentLetterId"
          loading={isFetching}
          pageInfo={data}
          size="small"
        />
      </Modal>
    </>
  );
};

export default LettersModal;
